module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v("t had been more than a week and she still couldn’t shake free of the feeling that her whole world was crashing in on her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was hard to focus, to try to pull herself out of this latest tailspin her life had gone into. Hard to put one foot in front of the other and go on. Though a child of luxury who had never wanted for anything, at least financially, Stephanie Yarbourough was no stranger to the tough curves and hardballs life could, without warning, suddenly throw at her. So far, she’d managed to dodge them all.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("First there’d been her mother. Joan Yarbourough had just picked up and disappeared, without so much as a card at Christmas to show that she still remem")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("bered she had left behind a daughter as well as a stepson when she’d walked out on her husband. It had taken time, but she’d gotten over that, Stephanie thought. Gotten over being forgotten at eight.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then there’d been Sebastian. He’s disappeared out of her life the summer before she turned twenty-one and she’d gotten over that, too, hadn’t she?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, maybe not altogether, but at least to the point where she’d become a functioning human being again, able to go on with her life. Anger had helped then. Anger had coated the hurt, the searing, bottomless pain of being summarily rejected without so much as a word of explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But this latest pitch that fate had hurled at her had hit her right between the eyes. After this one she just didn’t know if she was going to be able to summon the wherewithal to pull herself together again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt the kick. Or was that kicks? They came in quick succession, like dancers in a syncopated line, as if to remind her that she was never alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had no choice but to pull herself together, Stephanie told herself sternly, feeling her eyes beginning to sting. This wasn’t just about her, but about the babies she was carrying. This had happened to them as well as to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe even more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her mouth curved sadly as she lay her hand protectively over her swollen belly. Holly and Brett’s babies.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except that they were never going to be able to hold them, not now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you all right, Ms. Yarbourough?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blinking, she looked up to see the pharmacist looking at her over the raised counter. There was a touch of concern in his brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The concern deepened a degree as the old man looked at her more closely. “I said, ‘Are you all right, Ms. Yarbourough?’ You stopped signing the charge slip and looked as if you were somewhere else miles away from here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rueful smile came and went, replaced by a complacent one. Facades had always been part of her world and she had learned her lesson well at her father’s knee: never let them know what you’re thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie finished signing the slip and offered it back to the white-haired man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hopefully it was some place air-conditioned.” Silas Abernathy chuckled, separating the yellow copy from the others and snapping it off. He offered the slip to her. She noticed that a thatch of his hair was pasted to his forehead. “These voluntary brown-outs are a bear.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("“A little air is better than none,” Stephanie murmured philosophically, absently dropping the charge ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("slip into her purse. Weather, a nice, banal topic, she thought.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A wave of bitterness swept over her the next moment as she snapped her purse shut. Unseasonable heat had been the reason Holly and Brett had decided to go off on an impromptu, three-day vacation. A vacation they’d invited her to share, but, miserably uncomfortable in her condition, she’d opted to remain home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she hadn’t…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie shut the thought away. No sense in going there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good attitude,” Mr. Abernathy was saying, slipping her prescription into a small, slim bag. “Wish all my customers thought like you did. Can’t tell you how many come in here, complaining about the lack of air in the store. As if it was my idea to cut down on the power.” He shook his head. “And they’re not even in your condition.” He held out the bag to her, his eyes on her very swollen belly, a belly no amount of fabric, with its artful folds and layers, could any longer disguise. “Any day now, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because the man was as old as her grandfather would have been had he lived, and just as kindly, Stephanie took no offense at the very personal probing, though these last few days, she’d taken offense at almost anything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Any day now,” she confirmed brightly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And much, much too soon,")]), _vm._v(" she thought, taking the small paper bag with her prenatal vitamins in them. ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Extra prenatal vitamins her obstetrician, Sheila Pollack, had prescribed because she was still so dangerously anemic. The babies were taking a lot out of her.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t ready.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wasn’t ready to greet these babies she’d suddenly been placed in sole charge of. They weren’t supposed to be her babies, they were supposed to belong to Brett and Holly. She didn’t know if she could love them the way they were meant to be loved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Holly and Brett had been so eager, so filled with love for them from the very first moment the test had turned positive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe even before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Murmuring something that passed for “goodbye,” Stephanie turned away from the counter and made her way to the pharmacy’s electronic doors, feeling not unlike a lumbering bear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doors yawned open as she approached. With the doors no longer acting as a barrier, a blast of heat came at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She bit her lower lip as she stepped outside and the southern California heat surrounded her in an atypically hot, sweaty embrace. Even the air she drew into her lungs was heavy, daunting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was all supposed to have been so straightforward, so easy. Far less complicated than most surrogate mother arrangements. Her brother, Matthew, a corporate attorney, had insisted on documents being signed, though she’d never felt the need for that.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d done this out of love for a woman who had been closer to her than a sister—certainly closer to her than her own father had ever been.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hell, it had been her idea in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d volunteered to do this over Holly and Brett’s initial self-conscious protests. Desperate for a child, the couple still hadn’t wanted to put her through this. It had taken more than a little convincing on her part to make them both understand that this was something she was more than willing to do if it meant that they could ultimately have their life’s dream come true: a child of their very own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But “easy” had turned complicated right from the start.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The “child” had turned into “children” shortly after her pregnancy had been confirmed. Sheila had been bubbling with pleasure when she’d told her that she was pregnant not with one baby, but with two. The whole procedure had taken only two tries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fertility personified, that was her. But then she already knew that, she thought, fighting a second onslaught of tears. She and Sebastian had shared one time together, just one time, and she’d become pregnant with his child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A child he’d never even known about. A child she’d lost soon after she’d lost him. It was as if she wasn’t allowed to hang on to anything at all that would remind her of his ever having been in her life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Except for fading memories she couldn’t seem to ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("eradicate from her head no matter how often or how hard she tried.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no doubt in her mind that he’d long since purged her from his.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It didn’t matter. He wasn’t part of her life anymore, hadn’t been for seven years. But these babies were.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her hand went over her belly again. She had two babies on the way and no parents waiting in the wings to receive them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn, why did life have to keep getting this complicated? Why couldn’t things go right for a change? Was that asking too much?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dragging her hair off her neck, she stepped away from the marginal shade cast by the pharmacy’s awning and ventured out into the parking lot. She could feel the heat sizzling as it rose up along her legs. The asphalt felt as if it was going to liquefy with very little encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So, probably, she mused, could she. She’d never responded well to heat, and now, since she’d gotten pregnant, it was twice as bad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a sigh, Stephanie looked around, trying to remember where she had parked her car with its life-saving air-conditioning.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie Yarbourough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sight of her struck him with the force of a two-by-four being swung directly at his middle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("She wasn’t the last person he’d ever expected to ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("see here. After all, Bedford was her hometown, just as it had once been his. But he’d never expected to see her like that, her belly clearly distended beneath the wide, blue-and-white floral print dress.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie was carrying some other man’s child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And why not? he demanded of himself dourly. She damn well had a right to go on with her life. Wasn’t that what it had been all about, his leaving Bedford almost seven years ago? To allow her to go on with her life the way he knew in his heart it was really meant to go on? With someone from her own class. Someone who knew what fork to use, what words to say. Someone she would never find herself being ashamed of, who could make things happen for her the way he couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, that was what his leaving had been all about, he thought. But in all the time that had passed, he hadn’t once considered the possibility of Stephanie giving herself to anyone else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wanted to be her one and only, despite all your so-called noble intentions, didn’t you, Sebastian?")]), _vm._v(" he mocked himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it hadn’t been because of some vain desire on his part. It had been because he’d loved her. And wanted to go on loving her. Forever. And he’d wanted her to love him that way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Showed how naive the tough kid from the wrong side of the tracks had been, Sebastian thought cynically, leaning over the steering wheel of his abruptly ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("halted car to get a better look at her. In the pressed pages of his mind, Stephanie had remained eternally twenty, eternally innocent.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He debated driving on. Just shutting the image he’d just seen out of his mind and moving on, mentally and physically. After all, he hadn’t returned to Bedford because he wanted to pick up where he’d left off. He’d returned because he was needed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go, damn it, she hasn’t seen you. Go.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t listen. Instead, he pulled up the hand brake on the car and turned off the key in the ignition. A force greater than noble thoughts and the need for self-preservation had him getting out of the car close to where she was wandering through the parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stevi?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hearing the voice above the din of passing cars and stray voices in the lot, Stephanie froze. Despite the scorching heat, she felt s sharp chill zip like lightning up and down her spine. She told herself that she was hearing things, that she was imagining them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The way she’d thought and imagined his voice calling to her a hundred times since he’d left.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only one person in the world called her Stevi. And that person had gone out of her life almost seven years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her body and limbs suddenly leaden, Stephanie found herself turning stiffly toward the source of the voice—determined to prove to herself that she hadn’t heard what she thought she had.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Praying she hadn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Praying she had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eye contact was made instantly. Stephanie felt her heart stop beating for a second, then slam into her rib cage, accelerating so fast it threatened to make her dizzy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like a defense mechanism on a hair trigger, anger sprang up, immediate, full-grown and strong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Life wasn’t fair. Not on any count. Sebastian Caine wasn’t supposed to be here, wasn’t supposed to be so damn good-looking he could move a portrait of a woman to sigh in abject desire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face was leaner, tanner than she remembered. His expression—that “bad boy” look her father had always ranted about—seemed as if it was now permanently chiseled in. Sebastian looked all the more sensually attractive for it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if he needed that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d always been sensuality itself, just by breathing, by the way he’d looked at her. By the mere set of his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie stayed where she was, her hands fisted at her sides. Her car, her condition, everything else forgotten but the man who had suddenly materialized in her life without warning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just the way he’d disappeared.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("If life "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been fair, Sebastian would have gotten fatter, ugly and been balding, not have dark chestnut hair curling from the humidity at the back of his neck ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("and along his forehead. Hair she’d once dived her fingers through, glorying in the feel of it.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Damn you, Sebastian. Not now. Not after I’ve gotten over you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A little voice inside her said, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ha, sure you’ve gotten over him,")]), _vm._v(" but she ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her feet felt glued to the asphalt. As Sebastian walked toward her, she could almost see each muscle moving independently, yet in harmony, like a jaguar that was stalking its prey.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except that he had nothing to stalk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unless jaguars stalked overly pregnant women, she ridiculed herself. She felt as if she’d gained a thousand pounds within the last two seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What did it matter? He hadn’t wanted her when she’d been model-thin and completely willing to give up her world for him, she reminded herself. She’d made it clear she was willing to go anywhere with him, follow him to the ends of the earth. All that had mattered to her was being with him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she hadn’t mattered enough to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephanie lifted her chin as the distance between them decreased, searching for something to say even as her eyes swept the parking lot, trying to locate her car for a quick getaway. Why did she always forget where she parked? And why now of all times?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("What were the first words out of your mouth when you saw, after seven years, the man who broke your heart and set fire to your dreams? Did you rant? Did you ignore him? What? she thought in utter frustra")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("tion. Emily Post and her cohorts didn’t cover this in their books on proper etiquette.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe because proper ladies didn’t get dumped, Stephanie thought ruefully. Proper ladies didn’t pour out their hearts and let the man they loved know they loved him. There had been no mystery between Sebastian and her. Except the ultimate one—why he had left.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There it was, her car. One aisle over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because it was too far away to reach without passing him, she summoned all the years of training her father had tried to drum into her head—“So that I will never have reason to be ashamed of you”—and pasted a meaningless, distant smile on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Sebastian. How are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The frost in her voice hit him like the steep, sleek side of an iceberg. He should have just kept driving, Sebastian told himself. But he’d had to see her up close. Had to look at her, even though she belonged to some other man now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There’d been no choice on his part.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t that strong, hadn’t had the time, since arriving yesterday, to reinforce his shield against the only woman he’d ever allowed himself to love. He wanted to look into her eyes just one more time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe, if he was lucky, there’d be nothing there. For either of them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“I’m all right.” Never really talkative, he knew his reply sounded more stilted than even he could ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("bear. Without thinking, he took her hand, to shake it.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To touch her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You look good.” His eyes swept over her swollen form and he forced himself to smile. “I think the proper term is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("glowing.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s the heat,” she answered dismissively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Damn you, Sebastian, why did you walk out on me? Why did you leave me, wondering where you were? And why in the name of heaven are you back now?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he was back and she had to deal with it. Like a soldier, Stephanie squared her shoulders. “Are you back for a visit?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The slight smile on his lips turned enigmatic. “It’s a little more complicated than that,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("God, but you look good, Stevi. Too good.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian felt old urges rising up, as if they’d never faded away. Maybe they never had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had no business feeling that for her now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced over her head. There was a small, trendy coffee shop with half a dozen tables for two scattered out before it. New, he thought. Everything was new except for the way he felt about her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leave it alone. Say goodbye and go,")]), _vm._v(" he told himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took a chance, knowing he shouldn’t. “Maybe we could step out of the sun somewhere, have a cup of coffee for old times’ sake and I—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There is no “old times’ sake,” Sebastian,")]), _vm._v(" she ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("wanted to yell at him. Instead, she looked at him with a coolness that belied the churning emotions scrambling through her. With a snap of her wrist, Stephanie pulled her hand free as if it were being scalded.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think that would be very wise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Well, what had he expected?")]), _vm._v(" Still, disappointment shredded the veneer he was attempting to construct around himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, I understand. Jealous husband, eh?” He had no idea why he’d even said that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Deep blue eyes, eyes he’d loved to get lost in, cut him dead. “You lost the right to ask questions like that a long time ago, Sebastian.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With that, she turned away, knowing if she didn’t, she’d probably do something stupid, like throw her arms around him. Or demand to know why he’d hurt her the way he had. It would have been a humiliating waste of breath for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In seven years, Sebastian had never once seen fit to write to her, to call her, to get in contact some way and tell her why he had done what he had. She had no intentions of lowering herself now to ask. There was no reason for it. She knew the reason he’d left. Without her money—because her father would have cut her off without a dime—Sebastian hadn’t wanted her and she’d accepted that, accepted it no matter how much it had hurt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Her head held high, Stephanie walked to her car with as much dignity as she could gather. There was absolutely nothing to be gained by staying and talk")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("ing to him, she argued with herself. If she remained too long, Sebastian would see that there was a part of her that still, stupidly, cared for him. A part that had never let go, no matter how much she pretended that she had.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Numbly, quietly, he watched her. Watched her get into her car and start it up. As he stared after her, he vaguely noticed the vehicle’s color, make and license number like peripheral details of a dream he was trying to shake off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no point to this, Sebastian told himself. He’d just been passing through the small strip mall. There were a couple of videos his mother had requested sitting on the passenger side of the old car he’d driven here all the way from Seattle, Washington. He glanced at them now. If he didn’t get going, they were going to melt into the upholstery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn, but seeing her had jarred his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t need things like that. His life had been jarred enough. He had things to see to. He didn’t need this trip down a path he hadn’t been allowed to take.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like everything else, he thought, he’d find a way to deal with it. It was just going to take some time, that was all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just as he opened the driver’s side of his car, Sebastian heard the screech of tires in the distance behind him. Instinct had him swinging around to look back in Stephanie’s direction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("He’d turned just in time to see a large black sport ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("utility vehicle trying to swerve to avoid hitting Stephanie’s car.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The maneuver was not successful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The SUV’s blunt nose clipped Stephanie’s left front, sending it spinning as metal met metal. The two vehicles groaned from the impact.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought throbbed in his brain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hardly aware of shoving his car keys into his pocket, Sebastian grabbed his medical bag and was running toward Stephanie’s car before the image of the actual crash had a chance to completely sink in.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ecd2b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426870323_ch01.vue
// module id = 72
// module chunks = 0